import { InitAssistantData } from 'core_main/api/assistant/types';
import {
  AutomationsMetadataProactiveMessage,
  AutomationsMetadataResponse,
} from 'core_main/api/automations_metadata/types';
import { InitAssistantCallbackResponse } from './types';

export const createInitAssistantCallbackResponse = (
  data: InitAssistantData,
): InitAssistantCallbackResponse => {
  return {
    assistant: data?.meta?.assistant,
    dialog: data?.meta?.dialog,
    node: data?.meta?.node,
    initialMessages: data?.initialMessages,
    attributes: data?.attributes,
  };
};

export const normalizeAutomationMetadataAttributes = (
  attributes: AutomationsMetadataResponse['attributes'],
) => {
  return {
    aiUserId: attributes?.machineUser?.id,
    publicName: attributes?.machineUser?.displayName,
    avatarUrl: attributes?.machineUser?.avatarUrl,
  };
};

export const normalizeInitialMessages = (
  initialMessages: AutomationsMetadataProactiveMessage[] = [],
) => {
  return initialMessages.map(
    ({ body, ...messageWithoutBody }) => messageWithoutBody,
  );
};
